﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {CreateOrSelectResidencyModel} from "../components/CreateOrSelectResidencyComponent";
import IHolder from "../interfaces/IHolder";
import {ZoneId} from "../nominalTypes/ZoneId";
import {Residencies} from "../Residencies";
import {FormPermit} from "../types/arguments/FormPermit";

export default function updatePermitBranch(permit: FormPermit, result: CreateOrSelectResidencyModel, holder: IHolder): void {
	if (permit.branch == null) permit.branch = {zoneId: "" as ZoneId};
	let newZoneId: ZoneId | undefined;

	if (result.residencyId === "create") {
		newZoneId = result.arguments.zoneId

	} else {
		newZoneId = Residencies.get(holder, result.residencyId)?.zoneId;
	}

	if (isNullOrEmpty(newZoneId)) return;
	permit.branch.zoneId = newZoneId;
}
